/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".info-container[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%!important}\n/*# sourceMappingURL=information.component.css.map*/"];
export { styles as styles };
